import { KitchenTvApi } from '@/api';
import { Module } from 'vuex';
import { Actions, Mutations } from '.';
import { RootState } from './root.store';
import moment from 'moment';
import {
  TvRecentActivity,
  TvGeeksForLeaderboard,
  TvGeekForLeaderboard,
  TvLatestKudosPhotos,
  TvOpportunity,
} from '@/models/kitchen-tv';

const api = new KitchenTvApi();

export interface KitchenTvState {
  recentActivities: TvRecentActivity[];
  leaderboard: TvGeekForLeaderboard[];
  latestKudos: string[];
  opportunities: TvOpportunity[];
}

export const KitchenTvModule: Module<KitchenTvState, RootState> = {
  state: {
    recentActivities: [],
    leaderboard: [],
    latestKudos: [],
    opportunities: [],
  },
  mutations: {
    [Mutations.kitchenTv.setRecentActivities](state, response: TvRecentActivity[]) {
      state.recentActivities = response;
    },
    [Mutations.kitchenTv.setLeaderboard](state, response: TvGeeksForLeaderboard) {
      state.leaderboard = response.Geeks;
    },
    [Mutations.kitchenTv.setLatestKudosPhotos](state, response: TvLatestKudosPhotos) {
      state.latestKudos = response.PhotosLinks;
    },
    [Mutations.kitchenTv.setOpportunities](state, response: TvOpportunity[]) {
      state.opportunities = response;
    },
  },
  actions: {
    async [Actions.kitchenTv.fetchRecentActivities]({ commit }): Promise<void> {
      const todayDate = moment().format('YYYY-MM-DD');
      const response = await api.fetchRecentActivities(20, todayDate, 1);
      commit(Mutations.kitchenTv.setRecentActivities, response);
    },
    async [Actions.kitchenTv.fetchLeaderboard]({ commit }): Promise<void> {
      const todayDate = moment().format('YYYY-MM-DD');
      const response = await api.fetchGeeksForTvLeaderboard(10, todayDate);
      commit(Mutations.kitchenTv.setLeaderboard, response);
    },
    async [Actions.kitchenTv.fetchLatestKudosPhotos]({ commit }): Promise<void> {
      const response = await api.fetchLatestKudosPhotos();
      commit(Mutations.kitchenTv.setLatestKudosPhotos, response);
    },
    async [Actions.kitchenTv.fetchOpportunities]({ commit }): Promise<void> {
      const response = await api.fetchOpportunities();
      commit(Mutations.kitchenTv.setOpportunities, response);
    },
  },
};
